<template>
  <div style="height:100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="ref_field_setting" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="false" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" :isBusy="isBusy" :loading_width="100" :table_height_adjust="-8"
        :hb_table_class="'hb_table_price_disctable_class1'" @on_query="on_query" @state_change="state_change"
        :show_toolbar_button="[0, 0, 0, 0, 0]" @tool_invoke="tool_invoke" @current_changed="current_changed"
        @on_cell_button_click="on_cell_button_click" tableref="9c0397272f334dba81323580ccb5ac1b">
      </TableMain>
    </BaseContainer>
  </div>
</template>

<script>
import * as PriceDiscTableController from "../controllers/base/PriceDiscTableController"
import BaseContainer from "./components/BaseContainer"
import TableMain from "./components/table/TableMain"

export default {
  name: "TestFieldSetting",
  components: {
    BaseContainer,
    TableMain,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "测试",
      },
      fields: PriceDiscTableController.fields.default,
      dataForm: _.cloneDeep(PriceDiscTableController.dataForm),
      rules: PriceDiscTableController.rules,
      AccountRelation: "",
      SEI_Name: "",
      ItemRelation: "",
      dataAreaId: "",
      isBusy: false,
    }
  },
  created() { },
  methods: {
    async InvokeData() {
      // this.isBusy_table1 = true;
      // this.$refs.CustTable1.SetData([]);
      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.in_async"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })

      let _is_wait = true
      setTimeout(() => {
        if (_is_wait) {
          this.msgToasts(this.$t("notify.async_timeout"), "info")
          loading.close()
          _is_wait = false
        }
        return
      }, 1000 * 60 * 5)

      let _params = {
        company: "070",
        tableName: "secp_PriceDiscTable",
        accountNum: "", //不传则查询所有
      }
      await PriceDiscTableController.methods.pickAndInvoke(_params)

      loading.close()
      if (_is_wait) {
        this.msgToasts(this.$t("notify.async_success"), "success")
        _is_wait = false
      }
      this.isBusy = true
      if (isNaN(this._set_data) && isNaN(this._date_range)) {
        this.$refs.CustTable2.SetData([])
        let _params = {
          modifiedDateTime: {
            ">=": this.$date.format(
              new Date().setMonth(new Date().getMonth() - 1),
              "yyyy-MM-dd"
            ),
            "<=": this.$date.format(
              this.$date.addDays(new Date(), 1),
              "yyyy-MM-dd"
            ),
          },
        }
        let _result = await PriceDiscTableController.methods.getData(_params)

        if (!_.isNull(_result) && _result && _result.length > 0) {
          this.$refs.CustTable2.SetData(
            _.orderBy(_result[0], ["modifiedDateTime"], ["desc"])
          )
        }
      } else {
        await this.on_query(this._set_data, this._date_range)
      }
      this.isBusy = false
    },
    //#region 查询
    async on_query(set_data, date_range) {
      this.isBusy = true
      let _params = {}
      set_data([])
      _params.dataAreaId = '017'
      let _result = await PriceDiscTableController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        set_data(_.orderBy(_result[0], ["modifiedDateTime"], ["desc"]))
      }
      this.isBusy = false
    },
    //#endregion

    //#region 保存

    //#endregion

    //#region 状态切换
    state_change(data, cb) {

    },
    //#endregion

    //#region 打印导出
    tool_invoke(data, cb) { },
    //#endregion

    ///cell点击
    on_cell_button_click(data) {

    },

    current_changed(old, current) {

    },
  },
}
</script>

<style>
.hb_table_price_disctable_class1 {
  width: 100vw;
  font-size: 0.8rem;
  background-color: white;
  overflow-x: auto;
  /* min-width: 150rem; */
}
</style>
